module.exports = __webpack_public_path__ + "static/img/img05.a90a914.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img05.jpg
// module id = Hgmh
// module chunks = 18